import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoAdventFrame, LazySvgoAdventInside, LazySvgoAdventInsideMobile, LazySvgoAdventNumber02, LazySvgoAdventNumber04, LazySvgoAdventNumber08, LazySvgoAdventNumber08Mobile, LazySvgoAdventNumber09, LazySvgoAdventNumber11, LazySvgoAdventQuote, LazySvgoAdventSign1, LazySvgoAdventSign2, LazySvgoAdventSign3, LazySvgoAdventSign4, LazySvgoAdventSign5, LazySvgoAdventSign6, LazySvgoAdventSign7, LazySvgoAdventSign8, LazySvgoAdventSymbol01, LazySvgoAdventSymbol02, LazySvgoAdventSymbol03, LazySvgoAdventSymbol04, LazySvgoAdventSymbol05, LazySvgoAdventSymbol06, LazySvgoAdventSymbol07, LazySvgoAdventSymbol08, LazySvgoAdventSymbol09, LazySvgoAdventSymbol10, LazySvgoAdventSymbol11, LazySvgoAdventThing, LazySvgoBlogDay, LazySvgoBlogNight, LazySvgoError, LazySvgoLandingReshapeCard, LazySvgoLogoAbbreviation, LazySvgoLogoAdvent2026, LazySvgoLogoBlog, LazySvgoLogoFull, LazySvgoLogoHorizontal, LazySvgoLogoMission, LazySvgoLogoName, LazySvgoLogoReshape, LazySvgoPlaceholder, LazySvgoPressBlueprintNew, LazySvgoPressBuroNew2, LazySvgoPressForbesNew, LazySvgoPressRbcNew, LazySvgoPressUmagNew3, LazySvgoSimpleArrow, LazySvgoSimpleAuth, LazySvgoSimpleCaret, LazySvgoSimpleCart, LazySvgoSimpleCheck, LazySvgoSimpleCheckSolid, LazySvgoSimpleChevron, LazySvgoSimpleChevronDown, LazySvgoSimpleChevronLeft, LazySvgoSimpleChevronRight, LazySvgoSimpleChevronThinDown, LazySvgoSimpleClose, LazySvgoSimpleEdit, LazySvgoSimpleInstagram, LazySvgoSimpleMastercard, LazySvgoSimpleMinus, LazySvgoSimpleMir, LazySvgoSimplePlus, LazySvgoSimpleSister, LazySvgoSimpleStar, LazySvgoSimpleTelegram, LazySvgoSimpleUser, LazySvgoSimpleVisa, LazySvgoSimpleVk, LazySvgoSimpleYookassa, LazySvgoSimpleYoutube, LazySvgoSubscribeStep1, LazySvgoSubscribeStep2, LazySvgoSubscribeStep3, LazySvgoSubscribeStep4, LazySvgoSuccess, LazyProseCode, LazyProseEm, LazyProseH1, LazyProseH2, LazyProseH3, LazyProseH4, LazyProseH5, LazyProseH6, LazyProseHr, LazyProseLi, LazyProseP, LazyProsePre, LazyProseScript, LazyProseStrong, LazyProseTbody, LazyProseTd, LazyProseTh, LazyProseThead, LazyProseTr, LazyProseUl } from '#components'
const lazyGlobalComponents = [
  ["SvgoAdventFrame", LazySvgoAdventFrame],
["SvgoAdventInside", LazySvgoAdventInside],
["SvgoAdventInsideMobile", LazySvgoAdventInsideMobile],
["SvgoAdventNumber02", LazySvgoAdventNumber02],
["SvgoAdventNumber04", LazySvgoAdventNumber04],
["SvgoAdventNumber08", LazySvgoAdventNumber08],
["SvgoAdventNumber08Mobile", LazySvgoAdventNumber08Mobile],
["SvgoAdventNumber09", LazySvgoAdventNumber09],
["SvgoAdventNumber11", LazySvgoAdventNumber11],
["SvgoAdventQuote", LazySvgoAdventQuote],
["SvgoAdventSign1", LazySvgoAdventSign1],
["SvgoAdventSign2", LazySvgoAdventSign2],
["SvgoAdventSign3", LazySvgoAdventSign3],
["SvgoAdventSign4", LazySvgoAdventSign4],
["SvgoAdventSign5", LazySvgoAdventSign5],
["SvgoAdventSign6", LazySvgoAdventSign6],
["SvgoAdventSign7", LazySvgoAdventSign7],
["SvgoAdventSign8", LazySvgoAdventSign8],
["SvgoAdventSymbol01", LazySvgoAdventSymbol01],
["SvgoAdventSymbol02", LazySvgoAdventSymbol02],
["SvgoAdventSymbol03", LazySvgoAdventSymbol03],
["SvgoAdventSymbol04", LazySvgoAdventSymbol04],
["SvgoAdventSymbol05", LazySvgoAdventSymbol05],
["SvgoAdventSymbol06", LazySvgoAdventSymbol06],
["SvgoAdventSymbol07", LazySvgoAdventSymbol07],
["SvgoAdventSymbol08", LazySvgoAdventSymbol08],
["SvgoAdventSymbol09", LazySvgoAdventSymbol09],
["SvgoAdventSymbol10", LazySvgoAdventSymbol10],
["SvgoAdventSymbol11", LazySvgoAdventSymbol11],
["SvgoAdventThing", LazySvgoAdventThing],
["SvgoBlogDay", LazySvgoBlogDay],
["SvgoBlogNight", LazySvgoBlogNight],
["SvgoError", LazySvgoError],
["SvgoLandingReshapeCard", LazySvgoLandingReshapeCard],
["SvgoLogoAbbreviation", LazySvgoLogoAbbreviation],
["SvgoLogoAdvent2026", LazySvgoLogoAdvent2026],
["SvgoLogoBlog", LazySvgoLogoBlog],
["SvgoLogoFull", LazySvgoLogoFull],
["SvgoLogoHorizontal", LazySvgoLogoHorizontal],
["SvgoLogoMission", LazySvgoLogoMission],
["SvgoLogoName", LazySvgoLogoName],
["SvgoLogoReshape", LazySvgoLogoReshape],
["SvgoPlaceholder", LazySvgoPlaceholder],
["SvgoPressBlueprintNew", LazySvgoPressBlueprintNew],
["SvgoPressBuroNew2", LazySvgoPressBuroNew2],
["SvgoPressForbesNew", LazySvgoPressForbesNew],
["SvgoPressRbcNew", LazySvgoPressRbcNew],
["SvgoPressUmagNew3", LazySvgoPressUmagNew3],
["SvgoSimpleArrow", LazySvgoSimpleArrow],
["SvgoSimpleAuth", LazySvgoSimpleAuth],
["SvgoSimpleCaret", LazySvgoSimpleCaret],
["SvgoSimpleCart", LazySvgoSimpleCart],
["SvgoSimpleCheck", LazySvgoSimpleCheck],
["SvgoSimpleCheckSolid", LazySvgoSimpleCheckSolid],
["SvgoSimpleChevron", LazySvgoSimpleChevron],
["SvgoSimpleChevronDown", LazySvgoSimpleChevronDown],
["SvgoSimpleChevronLeft", LazySvgoSimpleChevronLeft],
["SvgoSimpleChevronRight", LazySvgoSimpleChevronRight],
["SvgoSimpleChevronThinDown", LazySvgoSimpleChevronThinDown],
["SvgoSimpleClose", LazySvgoSimpleClose],
["SvgoSimpleEdit", LazySvgoSimpleEdit],
["SvgoSimpleInstagram", LazySvgoSimpleInstagram],
["SvgoSimpleMastercard", LazySvgoSimpleMastercard],
["SvgoSimpleMinus", LazySvgoSimpleMinus],
["SvgoSimpleMir", LazySvgoSimpleMir],
["SvgoSimplePlus", LazySvgoSimplePlus],
["SvgoSimpleSister", LazySvgoSimpleSister],
["SvgoSimpleStar", LazySvgoSimpleStar],
["SvgoSimpleTelegram", LazySvgoSimpleTelegram],
["SvgoSimpleUser", LazySvgoSimpleUser],
["SvgoSimpleVisa", LazySvgoSimpleVisa],
["SvgoSimpleVk", LazySvgoSimpleVk],
["SvgoSimpleYookassa", LazySvgoSimpleYookassa],
["SvgoSimpleYoutube", LazySvgoSimpleYoutube],
["SvgoSubscribeStep1", LazySvgoSubscribeStep1],
["SvgoSubscribeStep2", LazySvgoSubscribeStep2],
["SvgoSubscribeStep3", LazySvgoSubscribeStep3],
["SvgoSubscribeStep4", LazySvgoSubscribeStep4],
["SvgoSuccess", LazySvgoSuccess],
["ProseCode", LazyProseCode],
["ProseEm", LazyProseEm],
["ProseH1", LazyProseH1],
["ProseH2", LazyProseH2],
["ProseH3", LazyProseH3],
["ProseH4", LazyProseH4],
["ProseH5", LazyProseH5],
["ProseH6", LazyProseH6],
["ProseHr", LazyProseHr],
["ProseLi", LazyProseLi],
["ProseP", LazyProseP],
["ProsePre", LazyProsePre],
["ProseScript", LazyProseScript],
["ProseStrong", LazyProseStrong],
["ProseTbody", LazyProseTbody],
["ProseTd", LazyProseTd],
["ProseTh", LazyProseTh],
["ProseThead", LazyProseThead],
["ProseTr", LazyProseTr],
["ProseUl", LazyProseUl],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
